import React from 'react';
import { Button, Dropdown, Menu, Tooltip } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import MenuItem from 'antd/lib/menu/MenuItem';
import { ANTD_GRAY } from '../../../../constants';
import { useTranslation } from '../../../../../../../i18n/useTranslation';

const DownArrow = styled(CaretDownOutlined)`
    && {
        padding-top: 4px;
        font-size: 14px;
        margin-left: 2px;
        margin-top: 2px;
        color: ${ANTD_GRAY[7]};
    }
`;

const StyledMenuItem = styled(MenuItem)`
    && {
        padding: 0px;
    }
`;

const ActionButton = styled(Button)`
    font-weight: normal;
`;

const DropdownWrapper = styled.div<{
    disabled: boolean;
}>`
    cursor: ${(props) => (props.disabled ? 'normal' : 'pointer')};
    color: ${(props) => (props.disabled ? ANTD_GRAY[7] : 'none')};
    display: flex;
    margin-left: 12px;
    margin-right: 12px;
`;

export type Action = {
    title: React.ReactNode;
    onClick: () => void;
};

type Props = {
    name: string;
    actions: Array<Action>;
    disabled?: boolean;
    tooltip?: string;
};

export default function ActionDropdown({ name, actions, disabled, tooltip }: Props) {
    const { t } = useTranslation();
    const tooltipTitle = tooltip || (disabled ? t('Please select atleast one entity to perform this action.') : '');
    return (
        <Tooltip title={tooltipTitle} overlayClassName="f-tooltip-white">
            <Dropdown
                disabled={disabled}
                trigger={['click']}
                overlay={
                    <Menu>
                        {actions.map((action) => (
                            <StyledMenuItem>
                                <ActionButton type="text" onClick={action.onClick}>
                                    {t(action.title as string)}
                                </ActionButton>
                            </StyledMenuItem>
                        ))}
                    </Menu>
                }
            >
                <DropdownWrapper className="f-color-high-contrast" disabled={!!disabled}>
                    {t(name)}
                    <DownArrow />
                </DropdownWrapper>
            </Dropdown>
        </Tooltip>
    );
}
